import { Alert, Grid } from '@mui/material'
import React, { useState } from 'react'
import LimiteLCTC from './LimiteLCTC'
import { FormFiltros, schemaFiltrosBusqueda, FiltrosBusqueda, FormFiltrosFields } from 'src/pages/limites/FiltrosBusqueda'
import { QueryStatus } from 'src/types'
import { SistemaTipo } from 'src/types/enum/enum'
import { OperacionLCTCLimitesAprobadosPaisFields } from '../../sistema/sistemas/lctc/types/fields'
import { useLimitesLCTC } from '../../sistema/sistemas/lctc/hooks/useLimites'

const LCTC_FORM_FIELDS = [
    FormFiltrosFields.Pais,
    FormFiltrosFields.UnidadNegocio,
    FormFiltrosFields.ClienteTipo,
    FormFiltrosFields.ClienteSubTipo
];

export function LimitesLCTC() {
    const [apiFiltros, setApiFiltros] = useState<FormFiltros>(
        schemaFiltrosBusqueda.parse({})
    )

    const { limites, status } = useLimitesLCTC(apiFiltros)

    const handleFilterChange = (nuevosFiltros: FormFiltros) => {
        setApiFiltros(nuevosFiltros)
    }

    return (
        <Grid container gap={10}>
            <Grid item xs={12} sx={{ mb: -5 }}>
                <FiltrosBusqueda
                    formFields={LCTC_FORM_FIELDS}
                    mensajeTipo={SistemaTipo.LCTC}
                    onFilterChange={handleFilterChange}
                />
            </Grid>

            {limites &&
                limites.map(l => (
                    <Grid item container xs={12} gap={5} key={l[OperacionLCTCLimitesAprobadosPaisFields.CodPais]}>
                        <Grid item xs={12}>
                            <LimiteLCTC data={l} />
                        </Grid>
                    </Grid>
                ))}
            <Grid item xs={12}>
                {(!limites?.length && status === QueryStatus.Success) && <Alert severity="warning">No se encontraron datos.</Alert>}
            </Grid>
        </Grid>
    )
}
